var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 79,
    viewBox: "0 0 78 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.2488 59.7834H60.0481L57.7957 54.9836L54.4465 62.1842L50.1843 51.2354L45.9826 59.7834H39.7114",
    stroke: "#0B63E5",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6936 35.3183C73.6276 32.5202 70.3065 30.704 66.56 30.704C62.7819 30.704 59.4354 32.5501 57.3731 35.3898C55.3116 32.5501 51.9652 30.704 48.187 30.704C45.3492 30.704 42.7547 31.7465 40.7656 33.4686C40.6145 33.5989 40.467 33.7338 40.324 33.8722C39.8399 34.3374 39.3965 34.845 39.0001 35.3898C38.6037 34.8441 38.1612 34.3374 37.6762 33.8722C37.5332 33.7338 37.3857 33.5998 37.2346 33.4686C35.2446 31.7465 32.6511 30.704 29.8123 30.704C26.035 30.704 22.6868 32.5501 20.6262 35.3898C18.563 32.5501 15.2174 30.704 11.4402 30.704C7.69284 30.704 4.37171 32.5202 2.30664 35.3183C5.16082 18.681 19.5901 5.87615 37.2346 5.07075C37.3812 5.06351 37.5287 5.05718 37.6762 5.05265C38.116 5.03636 38.5567 5.03003 39.0001 5.03003C39.4435 5.03003 39.8842 5.03727 40.324 5.05265C40.4715 5.05718 40.619 5.06351 40.7656 5.07075C58.4092 5.87615 72.8385 18.6819 75.6936 35.3183Z",
    stroke: "#0B63E5",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3251 3.32392V5.05417C39.8853 5.03788 39.4446 5.03154 39.0012 5.03154C38.5578 5.03154 38.117 5.03878 37.6772 5.05417V3.32392C37.6772 2.59273 38.27 2 39.0012 2C39.7324 2 40.3251 2.59273 40.3251 3.32392Z",
    stroke: "#0B63E5",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3252 33.8713V42.3597C39.6311 42.7787 38.9759 43.2872 38.3777 43.8854C38.2203 44.0428 38.0682 44.2048 37.9253 44.3704C37.8402 44.4664 37.7588 44.565 37.6782 44.6636V33.8713C38.1624 34.3365 38.6058 34.8441 39.0021 35.3889C39.3976 34.8441 39.841 34.3365 40.3252 33.8713Z",
    stroke: "#0B63E5",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.377 58.429L40.3244 60.3764V71.3135C40.3244 74.4156 37.8395 76.9911 34.7373 77.0001C33.1836 77.0047 31.7773 76.3766 30.7592 75.3586C29.7457 74.345 29.1177 72.9442 29.1177 71.3968V70.6158C29.1177 69.8846 29.7104 69.2919 30.4416 69.2919C31.1728 69.2919 31.7655 69.8846 31.7655 70.6158V71.337C31.7655 72.9533 33.0379 74.3161 34.6541 74.3514C35.4966 74.3704 36.2613 74.0356 36.8115 73.4863C37.3463 72.9505 37.6775 72.2121 37.6775 71.3958V57.6553C37.8956 57.9213 38.1282 58.1801 38.377 58.429Z",
    stroke: "#0B63E5",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6942 58.4283L55.5357 75.5877L44.0711 64.1222L38.3772 58.4283C38.1284 58.1794 37.8958 57.9206 37.6777 57.6546C34.6118 53.8928 34.6109 48.4251 37.6777 44.6633C37.7583 44.5647 37.8397 44.4669 37.9248 44.3701C38.0677 44.2045 38.2207 44.0416 38.3772 43.885C38.9754 43.2869 39.6306 42.7783 40.3246 42.3593C41.4884 41.6571 42.7644 41.2064 44.0711 41.0055C44.5932 40.9241 45.1208 40.8843 45.6484 40.8843C48.2836 40.8843 50.9206 41.8851 52.9205 43.8841L55.5348 46.4994L58.1501 43.8841C62.1499 39.8852 68.6944 39.8852 72.6933 43.8841C76.694 47.8849 76.694 54.4294 72.6942 58.4283Z",
    stroke: "#0B63E5",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.585 51.7025V58.295H18.4035V66.4756H11.8101V58.295H3.63037V51.7025H11.8101V43.521H18.4035V51.7025H26.585Z",
    stroke: "#0B63E5",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/Health.529ab5222dd2e38cd736b2d190159dc2.svg";
export { ForwardRef as ReactComponent };